module.exports = __webpack_public_path__ + "img/app_icon.1b4278c1.svg";